import { render, staticRenderFns } from "./Trinity.vue?vue&type=template&id=3588a79f&scoped=true&"
import script from "./Trinity.vue?vue&type=script&lang=js&"
export * from "./Trinity.vue?vue&type=script&lang=js&"
import style0 from "./Trinity.vue?vue&type=style&index=0&id=3588a79f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3588a79f",
  null
  
)

export default component.exports